import { render, staticRenderFns } from "./MaterialVariant.vue?vue&type=template&id=78cfed9a&scoped=true"
import script from "./MaterialVariant.vue?vue&type=script&lang=js"
export * from "./MaterialVariant.vue?vue&type=script&lang=js"
import style0 from "./MaterialVariant.vue?vue&type=style&index=0&id=78cfed9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cfed9a",
  null
  
)

export default component.exports